import React from 'react';
import { Link } from 'react-router-dom'; // needed for <Link>

const Footer = () => {
  return (
    <footer className="main-footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>HiveRooms</h3>
          <p>
            <a href="mailto:reservations@hiverooms.com">
              <i className="icon fas fa-envelope"></i> reservations@hiverooms.com
            </a>
          </p>
          <p>
            <a href="tel:+63322346236">
              <i className="icon fas fa-phone"></i> +63 32 234 6236
            </a>
          </p>
          <p>
            <i className="icon fas fa-house"></i> Unit #504, JESA I.T Center, General Maxilom Ave, Cebu City, CEBU, Philippines
          </p>
        </div>

        <div className="footer-section">
          <h4>Useful Links</h4>
          <ul>
            <li><Link to="/about-us">About Us</Link></li>
            <li><Link to="/partner-with-us">Partner with us</Link></li>
            <li><Link to="/news-room">Newsroom</Link></li>
            <li><Link to="/our-commitment">Our Commitment</Link></li>
          </ul>
        </div>

        <div className="footer-section__icons">
          <h4>Stay in touch</h4>
          <div className="footer-section__social">
            <p><a href="https://www.facebook.com/HiveRoomsDOTcom" target="_blank"><i className="fab fa-facebook"></i></a></p>
            <p><a href="https://www.instagram.com/hiverooms/" target="_blank"><i className="fab fa-instagram"></i></a></p>
            <p><a href="https://www.linkedin.com/company/hiverooms/" target="_blank"><i className="fab fa-linkedin-in"></i></a></p>
            <p><a href="https://www.tiktok.com/@hiverooms" target="_blank"><i className="fab fa-tiktok"></i></a></p>
            <p><a href="https://www.youtube.com/@HiveRooms" target="_blank"><i className="fab fa-youtube"></i></a></p>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; 2025 HiveRooms. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
